import React from 'react';
import { LocaleKey } from 'enums/locale-key.enum';
import Button from 'components/design-system/Button';
import SVGIcon from 'components/shared/SVGIcon';
const UnderMaintenance = () => {
    return (React.createElement("div", { className: "flex h-[100vh] w-[100vw] flex-col items-center justify-center gap-[24px] overflow-hidden bg-n-000 px-[64px]" },
        React.createElement(SVGIcon, { iconName: "icon-under-construction", width: 146 }),
        React.createElement("div", { className: "flex max-w-[400px] flex-col items-center gap-[12px]" },
            React.createElement("p", { className: "typography-h700 leading-[40px] text-n-900" }, LocaleKey.well_be_back_soon.h5locale().capitalize()),
            React.createElement("p", { className: "typography-h400 text-center leading-[24px] text-n-800" }, LocaleKey.happy5_is_currently_under_maintenance_we_apologize_for_the_inconvenience_and_appreciate_your_patience
                .h5locale()
                .capitalizeSentences())),
        React.createElement(Button, { onClick: () => window.location.reload(), id: "maintenance-refresh-button" }, LocaleKey.refresh.h5locale().capitalize())));
};
export default UnderMaintenance;
